import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicVerifPlace = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: 'Rechercher des conseils', link: '/topics/rechercher/recherche-conseils'},
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug}  titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Lors de votre<a target='_blank' className="link" href={`/topics/inscription/26`}>recherche,</a>
              sélectionnez votre compétition et votre catégorie. Si le bouton d'inscription indique <strong>s'inscrire</strong>, 
              cela signifie qu'il reste des places disponibles.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Le bouton d'inscription peut avoir plusieurs valeurs en fonction de l'ouverture ou non de la billeterie, ou si toutes les 
                places ont été vendues :
              </p>
              <ul>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    <strong>Inscriptions à venir :</strong> la billeterie n'est pas encore ouverte.
                  </p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    <strong>S'inscrire :</strong> vous pouvez alors poursuivre l'inscription en clquant sur le bouton
                  </p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text"><strong>Complet :</strong> toutes les places ont été vendues</p>
                </li>
              </ul>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicVerifPlace